import { axios } from '~/axios'

let saved_model = window.sessionStorage.getItem('models')

export const fetchModels = () => {
  if (saved_model) return saved_model
  
  return axios.get('/models').then(res => {
    const model = res.data.filter(d => d.default === 'yes')[0]
    const current_model = (model && model.type) || window.settings.serviceType
    window.sessionStorage.setItem('models', current_model)
    return current_model
  })
}
